/**
 * Call tracking: reports every click on a `tel:` link to Google Ads / GA4 via gtag,
 * including where on the site the click happened so conversions can be attributed.
 */

import { gtagSafe, GOOGLE_ADS_ID } from "./conversionTracking";

function resolveSource(link: HTMLAnchorElement): string {
  const explicit = link.closest<HTMLElement>("[data-call-source]");
  if (explicit?.dataset.callSource) return explicit.dataset.callSource;

  const section = link.closest<HTMLElement>("section[id], header, footer");
  if (section) {
    if (section.id) return section.id;
    return section.tagName.toLowerCase();
  }
  return "unknown";
}

export function trackPhoneCallClick(source: string, phoneNumber: string, label?: string) {
  const payload = {
    call_source: source,
    phone_number: phoneNumber,
    link_text: label,
    page_path: typeof window !== "undefined" ? window.location.pathname : undefined,
  };

  // GA4 / general analytics event
  gtagSafe("event", "phone_call_click", payload);
  // Google Ads click-to-call conversion signal
  gtagSafe("event", "conversion", {
    send_to: GOOGLE_ADS_ID,
    ...payload,
  });
}

/** Attach a single delegated listener that catches every tel: link on the site. */
export function initCallTracking() {
  if (typeof document === "undefined") return;

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target as HTMLElement | null;
      const link = target?.closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
      if (!link) return;

      const phoneNumber = link.getAttribute("href")!.replace(/^tel:/, "");
      const label = (link.getAttribute("aria-label") || link.textContent || "").trim().slice(0, 100);
      trackPhoneCallClick(resolveSource(link), phoneNumber, label);
    },
    true,
  );
}